export default {
    getAuthInfo: ['/cloudwarehouse/user/getAuthInfo', 'GET'],
    codeImage: ['/code/image', 'POST'],
    codeEmail: ['/code/email', 'POST'],
    register: ['/recruit/user/register', 'POST'],
    login: ['/recruit/user/login', 'POST'],
    forgetpassword: ['/recruit/user/forget/password', 'POST'],
    updatepassword: ['/recruit/user/update/password', 'POST'],
    updataEmail: ['/recruit/user/update/email', 'POST'],
    mark: ['/code/issue/mark', 'POST'],
    userinfo: ['/recruit/user/info', 'POST'],
    treelist: ['/area/tree/list', 'POST'],
    levellist: ['/area/level/list', 'POST'],
    dictionarylist: ['/dictionary/list', 'POST'],
    informationAdd: ['/recruit/information/add', 'POST'],
    informationUpdate: ['/recruit/information/update', 'POST'],
    informationList: ['/recruit/information/list', 'POST'],
    informationHandle: ['/recruit/information/handle', 'POST'],
    informationDelete: ['/recruit/information/delete', 'POST'],
    informationCopy: ['/recruit/information/copy', 'POST'],
    informationShare: ['/recruit/information/share', 'POST'],
    informationGetInfo: ['/recruit/information/getInfo', 'POST'],
    informationPublisherList: ['/recruit/information/publisherList', 'POST'],
    getRecruitParticipantList: ['/recruit/participant/getRecruitParticipantList', 'POST'],
    updateStatus: ['/recruit/participant/updateStatus', 'POST'],
    addScore: ['/recruit/participant/addScore', 'POST'],
    updateMoney: ['/recruit/participant/updateMoney', 'POST'],
    addEvaluate: ['/recruit/participant/addEvaluate', 'POST'],
    sharedList: ['/recruit/participant/sharedList', 'POST'],
    removeShare: ['/recruit/participant/removeShare', 'POST'],
    updatePower: ['/recruit/participant/updatePower', 'POST'],
    updateDate: ['/recruit/participant/updateDate', 'POST'],
    myParticipant: ['/recruit/participant/myParticipant', 'POST'],
    systemParticipant: ['/recruit/participant/systemParticipant', 'POST'],
    getParticipantInfo: ['/recruit/participant/getParticipantInfo', 'POST'],
    examineList: ['/recruit/user/examine/list', 'POST'],
    signList: ['/recruit/participant/sign/list', 'POST'],
    examine: ['/recruit/user/examine', 'POST'],
    getDetail: ['/recruit/user/getDetail', 'POST'],
    choseExaminer: ['/recruit/user/chose/examiner', 'POST'],
    handleBlock: ['/recruit/participant/handle/block', 'POST'],
    importParticipantData: ['/excel/importParticipantData', 'POST'],
    statistics: ['/recruit/participant/data/statistics', 'POST'],
    enlistStatistics: ['/recruit/participant/enlist/statistics', 'POST'],
    userStatistics: ['/recruit/participant/user/statistics', 'POST'],
    updateInfo: ['/recruit/user/update/info', 'POST'],
    shareinformation: ['/recruit/information/share/information', 'POST'],
    signInfo: ['/recruit/participant/sign/info', 'POST'],
    deletePeriod: ['/recruit/information/delete/period', 'POST'],
    enjoyTogether: ['/recruit/participant/enjoy/together', 'POST'],
    shareUser: ['/recruit/information/share/user', 'POST'],
    submitExamine: ['/recruit/information/submit/examine', 'POST'],
    examineStatus: ['/recruit/user/examine/status', 'POST'],
    dateList: ['/recruit/participant/date/list', 'POST'],
    notice: ['/recruit/user/email/notice', 'POST'],
    updateRemark: ['recruit/participant/updateRemark', 'POST'],
    perfectInfo: ['/recruit/user/perfect/info', 'POST'],
    chooseIdentity: ['/recruit/user/choose/identity', 'POST'],
    examineUser: ['/recruit/user/choose/examine/user', 'POST'],
    // 获取推送实验
    experimentPush: ['/recruit/information/push/list', 'POST'],
    // 推送被试
    recruitPush: ['/weChat/push/recruit', 'POST'],
    // 解绑微信
    wechatUnbind: ['/wechat/unbind?userId', 'GET'],
    // 微信扫码登录
    wechatLogin: ['/wechat/login', 'GET'],
};


// WEBPACK FOOTER //
// ./src/host/api/api.js